// src/components/EmailThread/FileGrid.jsx
import React from "react";
import { Checkbox, Modal } from "antd";
import PdfIcon from "../icons/PdfIcon";
import DocIcon from "../icons/DocIcon";
import UnknownIcon from "../icons/UnknownIcon";
import { limitWords } from "../../utils/utils";

const FileGrid = ({
  files,
  title,
  user_id,
  contract,
  handleSetMainFile,
  handlePreview,
  selectedIndex,
  setSelectedIndex,
}) => {
  if (!files?.length) return null;

  return (
    <div className="mt-2">
      <strong className="block mb-1">{title}:</strong>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
        {files.map((file, idx) => {
          const isPdf = file.file_url?.toLowerCase().endsWith(".pdf");
          const isDoc =
            file.file_url?.toLowerCase().endsWith(".docx") ||
            file.file_url?.toLowerCase().endsWith(".doc");

          return (
            <div
              key={idx}
              className="flex items-center gap-1 border rounded-md p-1 bg-white dark:bg-[#0E0E2C] shadow-sm w-full cursor-pointer"
            >
              {contract.editable_user === user_id && (
                <Checkbox
                  checked={selectedIndex === idx}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    setSelectedIndex(checked ? idx : null);

                    Modal.confirm({
                      title: "Make this the main agreement file?",
                      content:
                        "Are you sure you want to set this file as the main agreement?",
                      okText: "Yes",
                      cancelText: "No",
                      onOk: async () => {
                        try {
                          await handleSetMainFile(file.file_url);
                        } finally {
                          setSelectedIndex(null);
                        }
                      },
                      onCancel: () => setSelectedIndex(null),
                    });
                  }}
                />
              )}

              <div
                className="w-10 h-12 flex items-center justify-center"
                onClick={() => handlePreview(file.file_url)}
              >
                {isPdf ? (
                  <PdfIcon />
                ) : isDoc ? (
                  <DocIcon />
                ) : (
                  <UnknownIcon />
                )}
              </div>

              <div className="flex flex-col max-w-[170px]">
                <span className="text-[11px] font-medium text-gray-800 dark:text-gray-200 break-words">
                  {limitWords(file.file_name, 20)}
                </span>
                <span className="text-[10px] text-gray-500 truncate">
                  {new Date(file.uploaded_at).toLocaleString()}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FileGrid;
